// extracted by mini-css-extract-plugin
module.exports = {"cont-reviews":"cont-reviews","contReviews":"cont-reviews","container":"container"};